import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { Popconfirm } from "antd";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt, faTimes } from "@fortawesome/free-solid-svg-icons";
import filterCaseInsensitive from "helpers/react-table-case-insensitive";
import useSearchHook from "hooks/useSearch.hook";
import {
  openCustomModal,
  closeCustomModal
} from "views/lib/components/modals";
import { festiveDaysSearch, festiveDaysDelete } from "actions/festive-days/actions";
import Filters from "./filters";
import CreateModal from "./create-modal";

const FestiveDays = ({
                       festiveDaysSearch,
                       festiveDaysDelete,
                       openCustomModal,
                       closeCustomModal,
                       ...rest
                     }) => {
  const {
    loading,
    list,
    pages
  } = rest;

  const {
    page,
    size,
    filters,
    handleSearch,
    handleReset,
    handlePageChange,
    handleSortedChange,
    handlePageSizeChange
  } = useSearchHook(festiveDaysSearch, {
    size: 30,
    sort: "date,desc"
  });

  const handleDelete = (id) => {
    festiveDaysDelete(id);
  };

  const handleCreate = (id = false) => {
    const modalObj = {
      modalSettings: {
        size: "lg",
      },
      header: `${id ? "Update" : "Create"}`,
      children: (
        <CreateModal
          onCancel={() => closeCustomModal(modalObj)}
          id={id}
        />
      ),
      handleClose: () => closeCustomModal(modalObj)
    };
    openCustomModal(modalObj);
  };

  const getColumns = () => [
    {
      Header: "#",
      accessor: "id",
    },
    {
      Header: "Created Date",
      accessor: "creationDate",
      Cell: ({ original }) => moment(original.creationDate)
        .format("HH:mm YYYY-MM-DD"),
    },
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Active",
      accessor: "active",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <div className={original.active ? "text-success" : "text-danger"}>
          {original.active ? "Active" : "Inactive"}
        </div>
      )
    },
    {
      Header: "Type",
      accessor: "type",
    },
    {
      Header: "Minutes",
      accessor: "minutes",
    },
    {
      Header: "Date",
      accessor: "date",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <div>
          {original.type === "BIRTHDAY" || `${(original.day || "").toString()
            .padStart(2, 0)}-${(original.month || "").toString()
            .padStart(2, 0)}-XXXX`}
        </div>
      )
    },
    {
      id: "actions",
      Header: "Actions",
      className: "text-center",
      headerClassName: "text-center",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <React.Fragment>
          <button
            className="btn btn-sm btn-warning mr-3"
            onClick={() => handleCreate(original.id)}
          >
            <FontAwesomeIcon icon={faPencilAlt}/>
          </button>
          <Popconfirm
            title="Are you sure?"
            onConfirm={() => handleDelete(original.id)}
            placement="bottomRight"
            okText="Yes"
            cancelText="Cancel"
          >
            <button className="btn btn-sm btn-danger">
              <FontAwesomeIcon icon={faTimes}/>
            </button>
          </Popconfirm>
        </React.Fragment>
      )
    },
  ];

  return (
    <div className="w-100 p-2">
      <div className="filters">
        <Filters
          activeFilters={filters}
          totalCount={list.total_count || 0}
          handleSearch={handleSearch}
          handleReset={handleReset}
          handleCreate={() => handleCreate()}
        />
      </div>

      <ReactTable
        data={list.content || []}
        headerClassName="table-header"
        columns={getColumns()}
        pageSizeOptions={[10, 20, 50, 100]}
        resizable
        className="-striped -highlight table-header-padding"
        loading={loading}
        filterable={false}
        defaultFilterMethod={filterCaseInsensitive}
        style={{
          height: "calc(100vh - 140px)"
        }}
        manual={true}
        pages={pages}
        page={page}
        pageSize={size}
        onSortedChange={handleSortedChange}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  loading: state.festiveDays.loading,
  list: state.festiveDays.list,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  festiveDaysSearch: bindActionCreators(festiveDaysSearch, dispatch),
  festiveDaysDelete: bindActionCreators(festiveDaysDelete, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(FestiveDays);



// WEBPACK FOOTER //
// ./src/views/pages/festiveDays/index.js